import { useTranslation } from 'react-i18next';

// Rendered as a React element inside the toast container — it must be a real
// component (props object, JSX usage). Calling it as a plain function crashes
// with "Invalid hook call" because of useTranslation, which silently killed
// every foreground push toast.
const CustomNotification = ({ title, body }: { title: string; body: string }) => {
  const { t: te } = useTranslation('eaa');
  return (
    <div style={{ border: 'none', padding: '4px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="https://projoobacstrgpubacc.blob.core.windows.net/email-template/JooiceLogoSmall.svg"
          alt={te('alt.jooice-logo')}
          style={{ width: '30px', height: '30px', marginRight: '10px' }}
        />
        <h3
          style={{
            fontSize: '16px',
            fontWeight: '700',
            lineHeight: '22px',
            color: 'rgb(33, 43, 54)',
            margin: '5px 0 5px 0',
          }}
        >
          {title}
        </h3>
      </div>
      <p
        style={{
          margin: '5px 0 0 0',
          fontSize: '14px',
          fontWeight: '500',
          lineHeight: '22px',
          color: 'rgb(33, 43, 54)',
        }}
      >
        {body}
      </p>
    </div>
  );
};

export default CustomNotification;
